import { render } from "./UserPosts.vue?vue&type=template&id=4608c1af&scoped=true"
import script from "./UserPosts.vue?vue&type=script&lang=js"
export * from "./UserPosts.vue?vue&type=script&lang=js"

import "./UserPosts.vue?vue&type=style&index=0&id=4608c1af&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4608c1af"]])

export default __exports__